import styled from 'styled-components';

import { breakpoints, RadioButton, theme } from '@notino/react-styleguide';

export const FiltersSectionWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: ${theme.color.background.primary};
`;

export const FilterChipsWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem 1rem 0;

  @media (min-width: ${breakpoints.md}) {
    padding: 1.25rem 1rem 0.75rem;
  }
`;

export const StyledRadioButton = styled(RadioButton)`
  display: flex;
  align-items: center;
  height: 3rem;
  font-weight: 400;
  margin-left: 1.25rem;

  > span {
    top: 1rem;
    border-color: ${theme.color.border.divider};
  }
`;

export const Divider = styled.div<{ hideOnDesktop?: boolean }>`
  width: 100%;
  padding-bottom: 0.5rem;

  box-shadow: 0px 2px 4px 0px rgba(71, 71, 71, 0.1),
    0px 1px 2px 0px rgba(71, 71, 71, 0.06);

  @media (min-width: ${breakpoints.md}) {
    border-bottom: 1px solid ${theme.color.border.divider};
    box-shadow: none;
    width: calc(100% - 2rem);
    margin: 0 1rem;

    ${({ hideOnDesktop }) => hideOnDesktop && 'display:none;'}
  }
`;
